import * as z from "zod";

const GetCommerceCloudBacksyncStatusInputSchema_ = z.object({
  teamId: z.string(),
});

export const GetCommerceCloudBacksyncStatusInputSchema: z.ZodType<GetCommerceCloudBacksyncStatusInput> =
  GetCommerceCloudBacksyncStatusInputSchema_;
export interface GetCommerceCloudBacksyncStatusInput extends z.infer<
  typeof GetCommerceCloudBacksyncStatusInputSchema_
> {}

const GetCommerceCloudBacksyncStatusOutputSchema_ = z.object({
  configured: z.boolean(),
  syncInProgress: z.boolean().optional(),
});

export const GetCommerceCloudBacksyncStatusOutputSchema: z.ZodType<GetCommerceCloudBacksyncStatusOutput> =
  GetCommerceCloudBacksyncStatusOutputSchema_;
export interface GetCommerceCloudBacksyncStatusOutput extends z.infer<
  typeof GetCommerceCloudBacksyncStatusOutputSchema_
> {}

export const getCommerceCloudBacksyncStatus = {
  name: "getCommerceCloudBacksyncStatus" as const,
  input: GetCommerceCloudBacksyncStatusInputSchema,
  output: GetCommerceCloudBacksyncStatusOutputSchema,
};
